import { ReportMonthDateRange } from './../../model/report-month-date-range';
import { DateHelperService } from './../../services/date-helper.service';

		
		import { POLineItemDetailReportDTO } from './../../model/po-line-item-detail-report-dto';
    import { PartnerDto } from './../../model/partner-dto';
		import { PdfFileService } from './../../services/pdf-file.service';
		import { DatePipe } from '@angular/common';
		import { ExcelFileService } from './../../services/excel-file.service';
		import { FileExportService } from './../../services/file-export.service';
		import { ReportDateRangeDto } from './../../model/report-date-range-dto';
		import { HttpclientService } from './../../services/httpclient.service';
		import { AppSettingService } from './../../services/app-setting.service';
		import { Component, OnInit, TemplateRef } from '@angular/core';
		import * as moment from 'moment';
		import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
		import { ExceptionReportDto } from 'src/app/model/exception-report-dto';
		import { ModalModule, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-po-line-item-detail-report',
  templateUrl: './po-line-item-detail-report.component.html',
  styleUrls: ['./po-line-item-detail-report.component.css']
})
export class PoLineItemDetailReportComponent  implements OnInit {
  daterange ;
  dateRange:string="";
  loading : boolean;
  poLineItemDetailReportArray : POLineItemDetailReportDTO[];
  // selectedpoLineItemDetailReportArray : POLineItemDetailReportDTO[];
  poLineItemDetailReoprtListAllSelect  : POLineItemDetailReportDTO[];
  selectedpoLineItemDetailReportArray : POLineItemDetailReportDTO[];
  intialPOLineItemDetailReportList : POLineItemDetailReportDTO[];
  partnerNameList : PartnerDto[];
  customerNameList : PartnerDto[];

  partnerModal : string;
  customerModal : string;
  selectedAllRow: boolean;

  poLineItemDetailReportListAllSelect  : POLineItemDetailReportDTO[];

  maxDate: moment.Moment;

  count: number = 25;
  config: any;

  exportModal: string;
  exportList: string[] = ['Excel','PDF' ];
  selectedPOLineItemDetailReport: any = [];

  ispoDateSortCollapsedUpArrow: boolean;
  ispoDateSortCollapsedDownArrow: boolean;

  ispoNumberSortCollapsedUpArrow: boolean;
  ispoNumberSortCollapsedDownArrow: boolean;

  issoldToNumberSortCollapsedUpArrow: boolean;
  issoldToNumberSortCollapsedDownArrow: boolean;

  issoldToNameSortCollapsedUpArrow: boolean;
  issoldToNameSortCollapsedDownArrow: boolean;

  islineNumberSortCollapsedUpArrow: boolean;
  islineNumberSortCollapsedDownArrow: boolean;

  ismaterialGMCSortCollapsedUpArrow: boolean;
  ismaterialGMCSortCollapsedDownArrow: boolean;

  ismaterialQuantityOrderedSortCollapsedUpArrow: boolean;
  ismaterialQuantityOrderedSortCollapsedDownArrow: boolean;

  
constructor(private httpClient : HttpclientService,public appSettingService: AppSettingService,
        private pipe: PoOrderByPipe,public fileExportService: FileExportService,public pdfFileService: PdfFileService,
        public excelFileService: ExcelFileService,public datepipe: DatePipe
      ) { 
        this.poLineItemDetailReportArray = [];
        this.exportModal = this.exportList[0];
        this.config = {
          currentPage: 1,
          itemsPerPage: 25
        };
}

ngOnInit() {
    this.partnerModal ="-1";
    this.customerModal ="-1";
    this.getPartnersName();
    this.getCustomersName();
    this.maxDate = moment().add(0, 'days');
    this.exportModal = this.appSettingService.exportList[0];
}

getCustomersName(){
    this.loading=true;
    this.httpClient.getCustomersName().subscribe(
      data => {
        
        this.customerNameList=data;
        
        this.loading=false;
      }
    )
}


getPartnersName(){
    this.loading=true;
    this.httpClient.getPartnersName().subscribe(
      data => {
        this.partnerNameList=data;
        this.loading=false;
      }
    )
}

onChangeSelectedPartner(){
    console.log("onChangeSelectedPartner");
  if(this.partnerModal!="-1" ){
    console.log(" partner > "+this.partnerModal);
    this.customerModal="-1";
    this.partnerModal=this.partnerModal;
  this.selectedpoLineItemDetailReportArray=[]; 
  var len = this.intialPOLineItemDetailReportList.length;
  
  var j =0;
  for(var i=0;i<len;i++){
    console.log("this.intialPOLineItemDetailReportList[i].soldToNumber:"+this.intialPOLineItemDetailReportList[i].partnerNumber)
    if(this.partnerModal == this.intialPOLineItemDetailReportList[i].partnerNumber){
      this.selectedpoLineItemDetailReportArray[j]=this.intialPOLineItemDetailReportList[i]
      j++;
    }
  }
  this.poLineItemDetailReportArray=this.selectedpoLineItemDetailReportArray;
  }else if(this.partnerModal=="-1"){
    this.poLineItemDetailReportArray=this.intialPOLineItemDetailReportList;
  }
}
		  
getPOLineItemDetailReport(){
    var startDate = this.daterange.start.format('YYYY-MM-DD');
    var endDate = this.daterange.end.format('YYYY-MM-DD');
    this.loading=true;
    this.httpClient.getPOLineItemDetailReport(startDate, endDate).subscribe(
      data => {
        
        this.poLineItemDetailReportArray=data;
        this.intialPOLineItemDetailReportList=data;
        this.loading=false;
        var len = this.poLineItemDetailReportArray.length;
        console.log("len"+len);
        for(let i = 0;i < len;i++) {
          console.log("this.poLineItemDetailReportArray["+i+"].materialQtyOrdered"+this.poLineItemDetailReportArray[i].materialQuantityOrdered);
        }
        
      }
    )
} 

initialSortValue() {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
    this.issoldToNumberSortCollapsedUpArrow=true;
    this.issoldToNumberSortCollapsedDownArrow=true;
    this.issoldToNameSortCollapsedUpArrow=true;
    this.issoldToNameSortCollapsedDownArrow=true;
    this.islineNumberSortCollapsedUpArrow=true;
    this.islineNumberSortCollapsedDownArrow=true;
    this.ismaterialGMCSortCollapsedUpArrow=true;
    this.ismaterialGMCSortCollapsedDownArrow=true;
    this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
    this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
}

ChangeSortOrder(exportData) {
   this.exportModal = exportData;
}

// onChangeSelectedCustomer(){
//   if(this.customerModal!="-1" ){
//     console.log(" customer > "+this.customerModal);
//     this.partnerModal="-1";
//     this.customerModal=this.customerModal;
//     this.selectedPartnerBOLReportArray=[]; 
//     var len = this.intialPOLineItemDetailReportList.length;
//     var j =0;
//     // this.customerModal = this.customerModal.toUpperCase();
//     // const localCustomer  = this.customerModal;
//     console.log("upper"+this.customerModal);
    
//     for(let i = 0;i < len;i++) {
//       // if(this.customerModal === this.intialPOLineItemDetailReportList[i].editpid){
//       //   this.selectedPartnerBOLReportArray[j] = this.intialPOLineItemDetailReportList[i]
//       //   j++;
//       // }
//     }
//     this.poLineItemDetailReportArray = this.selectedPartnerBOLReportArray;
//     }else if(this.customerModal === '-1'){
//       this.poLineItemDetailReportArray = this.intialPOLineItemDetailReportList;
//     }
        
// }

changerecordperpage(value) {
  this.config.itemsPerPage = value;
  this.count = value;
}

modalPopup : boolean=false;
modalPopupString: string;

pressingOK(){
   this.modalPopup=false;
}

export() {
  if(this.poLineItemDetailReportArray == null || this.poLineItemDetailReportArray == undefined || this.poLineItemDetailReportArray.length === 0){
    this.modalPopupString="No Data to Export";
    this.modalPopup=true;
    return;
  }
        
  let flag : boolean;
       
  if (this.fileExportService.selectedPOLineItemDetailReportData.length === 0) {
    flag=true;
    this.poLineItemDetailReportListAllSelect = [];
    this.poLineItemDetailReportArray.forEach(polineitemdto => {
      polineitemdto.rowCheck = true;
      this.poLineItemDetailReportListAllSelect.push(polineitemdto);
    });
    this.poLineItemDetailReportArray = this.poLineItemDetailReportListAllSelect;
    this.fileExportService.selectedPOLineItemDetailReportData = this.poLineItemDetailReportListAllSelect;
  } 
    if (this.exportModal === 'PDF') {
      this.pdfFileService.exportPOLineItemDetailReportTable('PO Line Item Detail Report Table');
    } else if (this.exportModal === 'Excel') {
      this.selectedPOLineItemDetailReport = [];
      this.fileExportService.selectedPOLineItemDetailReportData.forEach(polineitemdto => {
        if (polineitemdto.rowCheck) {
          var shippedQtyStr;
          if(polineitemdto.poDate == null || polineitemdto.poDate == ""  || polineitemdto.poDate == undefined){
            polineitemdto.poDate="";
          }
          if(polineitemdto.poNumber == null || polineitemdto.poNumber == "" || polineitemdto.poNumber == undefined){
            polineitemdto.poNumber="";
          }
          // else{
          //   bdto.poDate = this.datepipe.transform(bdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
          // }
          if(polineitemdto.soldToNumber == null || polineitemdto.soldToNumber == "" || polineitemdto.soldToNumber == undefined){
            polineitemdto.soldToNumber="";
          }
          // else{
          //   bdto.bolCreatedDate = this.datepipe.transform(bdto.bolCreatedDate, this.appSettingService.globelDatePickerInUSAFormat) ;
          // }
          if(polineitemdto.soldToName == null || polineitemdto.soldToName == "" || polineitemdto.soldToName == undefined){
            polineitemdto.soldToName="";
          }
          if(polineitemdto.lineNumber == null || polineitemdto.lineNumber == "" || polineitemdto.lineNumber == undefined){
            polineitemdto.lineNumber="";
          }
          if(polineitemdto.materialGMC == null || polineitemdto.materialGMC == "" || polineitemdto.materialGMC == undefined){
            polineitemdto.materialGMC="";
          }

          if(polineitemdto.axaltaCode == null || polineitemdto.axaltaCode == "" || polineitemdto.axaltaCode == undefined){
            polineitemdto.axaltaCode="";
          } 

          if(polineitemdto.discription == null || polineitemdto.discription == "" || polineitemdto.discription == undefined){
            polineitemdto.discription="";
          } 

          if(polineitemdto.materialQuantityOrdered == null || polineitemdto.materialQuantityOrdered == "" || polineitemdto.materialQuantityOrdered == undefined){
            polineitemdto.materialQuantityOrdered="";
          } 

          if(polineitemdto.qtshipped == null || polineitemdto.qtshipped == "" || polineitemdto.qtshipped == undefined){
            polineitemdto.qtshipped="0";
          }            

          this.selectedPOLineItemDetailReport.push({
            'PO Date': `` + `${polineitemdto.poDate}`,'PO Number': `` + `${polineitemdto.poNumber}`,'Sold To Number': `${polineitemdto.soldToNumber}`,
            'Sold To Name': `${polineitemdto.soldToName }`,'Line Number': `${polineitemdto.lineNumber}`, 'Material GMC': `${polineitemdto.materialGMC}`,
             'Axalta Code': `${polineitemdto.axaltaCode}`, 'Description': `${polineitemdto.discription}`, 
            'Material Ordered Quantity': `${polineitemdto.materialQuantityOrdered}`,'Quantity Shipped': `${polineitemdto.qtshipped}`,
          });
        }
      });
      this.excelFileService.exportPOLjneItemDetailReportTableExcel(this.selectedPOLineItemDetailReport, 'PO Line Item Detail Report Table');
    }
    if(flag){
      this.poLineItemDetailReoprtListAllSelect = [];
      this.poLineItemDetailReportArray.forEach(pdto => {
        pdto.rowCheck = false;
        this.poLineItemDetailReoprtListAllSelect.push(pdto);
      });
      this.poLineItemDetailReportArray = this.poLineItemDetailReoprtListAllSelect;
      this.fileExportService.selectedPOLineItemDetailReportData = [];
    }
}

pageChanged(event) {
        this.config.currentPage = event;
      }
      onSelect(selectedItem: any, values: any) {
        let checkStaus = true;
        if (values.currentTarget.checked) {
    
          this.fileExportService.selectedPOLineItemDetailReportData.push(selectedItem);
        } else if (!values.currentTarget.checked) {
    
          this.fileExportService.selectedPOLineItemDetailReportData = this.fileExportService.selectedPOLineItemDetailReportData.filter(obj => obj !== selectedItem);
         
        }
    
        if(this.fileExportService.selectedPOLineItemDetailReportData.length === this.poLineItemDetailReoprtListAllSelect.length){
          this.selectedAllRow = true;
        }else{ 
          this.selectedAllRow = false;
        }
        
    
 }


 sortArry : POLineItemDetailReportDTO[];
 onChangeSort(event: any, upDown: boolean, propertyName: string) {
      this.intialPOLineItemDetailReportList=this.poLineItemDetailReportArray;
      if (propertyName === 'poDate' ) {
        // this.ispoDateSortCollapsedUpArrow=true;
        // this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
       if (upDown) {
     this.sortArry = [];
     this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, upDown);
     this.poLineItemDetailReportArray = [];
     this.poLineItemDetailReportArray = this.sortArry;
     this.ispoDateSortCollapsedUpArrow = !this.ispoDateSortCollapsedUpArrow;
     this.ispoDateSortCollapsedDownArrow = true;
  } else {
   this.sortArry = [];
   this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, upDown);
   this.poLineItemDetailReportArray = [];
   this.poLineItemDetailReportArray = this.sortArry;
   this.ispoDateSortCollapsedDownArrow = !this.ispoDateSortCollapsedDownArrow;
   this.ispoDateSortCollapsedUpArrow = true;
  }
   } 
      else if (propertyName === 'poNumber' ) {
        this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        // this.ispoNumberSortCollapsedUpArrow=true;
        // this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, upDown);
      this.poLineItemDetailReportArray = [];
      this.poLineItemDetailReportArray = this.sortArry;
      this.ispoNumberSortCollapsedUpArrow = !this.ispoNumberSortCollapsedUpArrow;
      this.ispoNumberSortCollapsedDownArrow = true;
  } else {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, upDown);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.ispoNumberSortCollapsedDownArrow = !this.ispoNumberSortCollapsedDownArrow;
    this.ispoNumberSortCollapsedUpArrow = true;
  }
    } else if (propertyName === 'soldToNumber' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        // this.issoldToNumberSortCollapsedUpArrow=true;
        // this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, true);
      this.poLineItemDetailReportArray = [];
      this.poLineItemDetailReportArray = this.sortArry;
      this.issoldToNumberSortCollapsedUpArrow = !this.issoldToNumberSortCollapsedUpArrow;
      this.issoldToNumberSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, false);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.issoldToNumberSortCollapsedDownArrow = !this.issoldToNumberSortCollapsedDownArrow;
    this.issoldToNumberSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'soldToName' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        // this.issoldToNameSortCollapsedUpArrow=true;
        // this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, true);
      this.poLineItemDetailReportArray = [];
      this.poLineItemDetailReportArray = this.sortArry;
      this.issoldToNameSortCollapsedUpArrow = !this.issoldToNameSortCollapsedUpArrow;
      this.issoldToNameSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, false);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.issoldToNameSortCollapsedDownArrow = !this.issoldToNameSortCollapsedDownArrow;
    this.issoldToNameSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'lineNumber' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        // this.islineNumberSortCollapsedUpArrow=true;
        // this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, true);
      this.poLineItemDetailReportArray = [];
      this.poLineItemDetailReportArray = this.sortArry;
      this.islineNumberSortCollapsedUpArrow = !this.islineNumberSortCollapsedUpArrow;
      this.islineNumberSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, false);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.islineNumberSortCollapsedDownArrow = !this.islineNumberSortCollapsedDownArrow;
    this.islineNumberSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'materialGMC' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        // this.ismaterialGMCSortCollapsedUpArrow=true;
        // this.ismaterialGMCSortCollapsedDownArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, true);
      console.log("property"+propertyName);
      this.poLineItemDetailReportArray = [];
      this.poLineItemDetailReportArray = this.sortArry;
      this.ismaterialGMCSortCollapsedUpArrow = !this.ismaterialGMCSortCollapsedUpArrow;
      this.ismaterialGMCSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, false);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.ismaterialGMCSortCollapsedDownArrow = !this.ismaterialGMCSortCollapsedDownArrow;
    this.ismaterialGMCSortCollapsedUpArrow = true;
  } 
  } else if (propertyName === 'materialQuantityOrdered' ) {
    this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.issoldToNumberSortCollapsedUpArrow=true;
        this.issoldToNumberSortCollapsedDownArrow=true;
        this.issoldToNameSortCollapsedUpArrow=true;
        this.issoldToNameSortCollapsedDownArrow=true;
        this.islineNumberSortCollapsedUpArrow=true;
        this.islineNumberSortCollapsedDownArrow=true;
        this.ismaterialGMCSortCollapsedUpArrow=true;
        this.ismaterialGMCSortCollapsedDownArrow=true;
        // this.ismaterialQuantityOrderedSortCollapsedUpArrow=true;
        // this.ismaterialQuantityOrderedSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, true);
    console.log("property"+propertyName);
    this.poLineItemDetailReportArray = [];
    this.poLineItemDetailReportArray = this.sortArry;
    this.ismaterialQuantityOrderedSortCollapsedUpArrow = !this.ismaterialQuantityOrderedSortCollapsedUpArrow;
    this.ismaterialQuantityOrderedSortCollapsedDownArrow = true;
  } else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPOLineItemDetailReportList, propertyName, false);
  this.poLineItemDetailReportArray = [];
  this.poLineItemDetailReportArray = this.sortArry;
  this.ismaterialQuantityOrderedSortCollapsedDownArrow = !this.ismaterialQuantityOrderedSortCollapsedDownArrow;
  this.ismaterialQuantityOrderedSortCollapsedUpArrow = true;
  }
  } 
   
}
}
